export enum ROUTE_PATHS {
  EDITOR = '',
  NOT_FOUND = '*',
  GOOGLE_LOGIN = 'google-login',
  EDITOR_NEW = 'editor-new',
  UPLOAD_SMARTPHONE = 'upload-smartphone',
  UPLOAD_FAMILY_FRIENDS = 'upload-family-friends',
  UPLOAD = 'upload',
  LOGIN = 'login',
  EDIT = 'edit',
  STORYBOOK = 'storybook',
}

export enum ROUTE_NAMES {
  GoogleLogin = 'GoogleLogin',
  Editor = 'Editor',
  EditorNew = 'EditorNew',
  UploadSmartphone = 'UploadSmartphone',
  UploadFamilyFriends = 'UploadFamilyFriends',
  NotFound = 'NotFound',
  Upload = 'Upload',
  Login = 'Login',
  Edit = 'Edit',
  Storybook = 'Storybook',
}

export const SKIPPED_INIT_PROJECTS_PATHS = [
  ROUTE_PATHS.UPLOAD_SMARTPHONE,
  ROUTE_PATHS.UPLOAD_FAMILY_FRIENDS,
  ROUTE_PATHS.GOOGLE_LOGIN,
  ROUTE_PATHS.LOGIN,
  ROUTE_PATHS.STORYBOOK,
];
